import { COLLAPSE_STATE_CHANGED, collapseEventTarget } from 'features/shared/collapseStorage';

import { SMART_RATE_FAQ_SECTION_SCOPE } from './SmartRateFaqs.constants';

export const makeSmartRateFaqSectionId = faqContentfulId => `smart-rate-faq-${faqContentfulId}`;

export const makeSmartRateFaqTriggerId = sectionId => `${sectionId}-trigger`;

export const isSmartRateFaqPublished = (faqs, faqContentfulId) => faqs.some(({ id }) => id === faqContentfulId);

export const expandSmartRateFaqSection = sectionId => {
  collapseEventTarget.dispatchEvent(
    new CustomEvent(COLLAPSE_STATE_CHANGED, {
      detail: { storageKey: SMART_RATE_FAQ_SECTION_SCOPE, sectionId, isOpen: true },
    })
  );
};

export const scrollToSmartRateFaq = faqContentfulId => {
  const sectionId = makeSmartRateFaqSectionId(faqContentfulId);
  expandSmartRateFaqSection(sectionId);

  requestAnimationFrame(() => {
    document.getElementById(makeSmartRateFaqTriggerId(sectionId))?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  });
};

export const navigateToSmartRateFaq = (faqContentfulId, { beforeScroll } = {}) => {
  if (beforeScroll) {
    beforeScroll();
    requestAnimationFrame(() => scrollToSmartRateFaq(faqContentfulId));
    return;
  }

  scrollToSmartRateFaq(faqContentfulId);
};
